import $i18n from '@alife/panda-i18n';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { CnDialog, CnMessage, CnButton, CnIcon, CnCard, CnTable, } from '@alife/cn-ui';
import AddFrom from './components/add-form';
import AddPayer from './components/add-player';
import CpForm from './components/cp-form';
import PublicDialog from './components/public-dialog';
import { componentName } from './const';
import { checkCanUseCnSelfVas, setSourceType, getCnValueAddedServiceType, } from './api';
import './index.scss';
import { useTable } from './hooks';
/**
 *  交货单--增值服务 - 三期
 */
function BizValueAddedService(props) {
    const { config = {}, selectedRowRecords = [], disabled, source = 'asn', buttonConfig = {}, componentType = 'button', size = 'medium', } = props;
    const [record = {}] = selectedRowRecords;
    const { children: l2ButtonName } = buttonConfig;
    const [addDialogMode, setAddDialogMode] = useState(null); // 新增/编辑 - 弹框
    const [dialogStuVisible, setDialogStuVisible] = useState(false); // 增值服务 - 弹框
    const [affirmDialogVisible, setAffirmDialogVisible] = useState(false); // 确认 - 弹框
    const [jumpCashierUrl, setJumpCashierUrl] = useState(null); // 确认 - 弹框 - 支付弹框
    const [closeService, setCloseService] = useState(false); // 取消服务 - 弹框
    const [serviceList, setServiceList] = useState([]);
    const [editorRecord, setEditRecord] = useState(null);
    const [canAddService, setCanAddService] = useState(false);
    const { asnCode, billTypeName } = useMemo(() => {
        let code;
        let name;
        if (source === 'asn') {
            name = $i18n.get({ id: 'DeliveryNumber', dm: '交货单号' });
            code = record.asnCode;
        }
        else {
            name = $i18n.get({ id: '31255242054176769.CNTM', dm: '派车单号' });
            code = record.code;
        }
        return {
            asnCode: code,
            billTypeName: name,
        };
    }, [record, source]);
    // 服务弹窗
    const handleShowServiceDialog = useCallback((type = 'new', recordData = {}) => {
        setEditRecord(recordData);
        setAddDialogMode(type);
    }, []);
    const { handleSearch, selfVasDetailList, existedServiceType, tableLoading, headers, canEdit, operateColumns, } = useTable({
        asnCode,
        setEditRecord,
        handleShowServiceDialog,
        setCloseService,
        setAffirmDialogVisible,
    });
    useEffect(() => {
        setSourceType(source);
    }, [source]);
    // 校验是否 - 可增值服务
    const onCheckCanUse = useCallback(() => {
        if (selectedRowRecords?.length === 0) {
            return CnMessage.warning($i18n.get({
                id: 'PleaseSelectAtLeastOneRecord_858803615',
                dm: '请至少选择一项记录',
            }));
        }
        if (selectedRowRecords?.length > 1) {
            return CnMessage.warning($i18n.get({
                id: 'OnlyOneRecordCanBeSelected_1256155015',
                dm: '只能选择一项记录',
            }));
        }
        checkCanUseCnSelfVas({
            asnCode,
        })
            .then(() => {
            setDialogStuVisible(true);
        })
            .catch((e) => {
            const message = e?.message || e?.code || '';
            CnMessage.error(message);
        });
    }, [asnCode, selectedRowRecords]);
    // 服务 - 获取服务项列
    const getServiceList = useCallback(() => {
        getCnValueAddedServiceType()
            .then((res) => {
            const { data: list } = res;
            setServiceList(list);
        })
            .catch(() => {
            setServiceList([]);
        });
    }, [setServiceList]);
    useEffect(() => {
        if (dialogStuVisible) {
            getServiceList();
            handleSearch();
        }
    }, [dialogStuVisible, getServiceList, handleSearch]);
    return (React.createElement(React.Fragment, null,
        componentType !== 'button' ? (React.createElement(CnButton, { onClick: () => onCheckCanUse(), disabled: disabled, component: 'a', type: 'primary', text: true, className: source === 'asn' ? 'art-table-operate-btn' : '' }, l2ButtonName || config?.name)) : (React.createElement(CnButton, { className: 'biz-button-value-added', onClick: () => onCheckCanUse(), disabled: disabled, size: size }, l2ButtonName || config?.name)),
        dialogStuVisible ? (React.createElement(CnDialog, { size: 'large', className: 'asn', title: React.createElement("div", null,
                $i18n.get({
                    id: 'CainiaoWarehouseService',
                    dm: '菜鸟仓内服务｜',
                }),
                billTypeName,
                asnCode || '-'), visible: true, footer: false, onClose: () => {
                setEditRecord(null);
                setDialogStuVisible(false);
            } },
            React.createElement(React.Fragment, null,
                React.createElement(AddPayer, { asnCode: asnCode, canEdit: canEdit, setCanAddService: setCanAddService }),
                React.createElement(CnCard, { title: $i18n.get({
                        id: 'CainiaoWarehouseService_CNCNFW',
                        dm: '2.菜鸟仓内服务',
                    }), action: React.createElement(React.Fragment, null,
                        React.createElement(CnIcon, { className: 'biz-value-added-refresh-icon', type: 'refresh', size: 'medium', style: { marginRight: 4 }, onClick: () => {
                                handleSearch();
                            } }),
                        React.createElement(CnButton, { size: 'medium', type: 'primary', disabled: !canAddService, onClick: () => handleShowServiceDialog('new') }, $i18n.get({ id: 'NewService', dm: '新增服务' }))), style: { marginBottom: 'var(--form-item-m-margin-b,12px)' } },
                    React.createElement(CnTable, { loading: tableLoading, columns: headers, dataSource: selfVasDetailList, isZebra: true, showIndex: 1, size: 'small', operateColumn: operateColumns, cellCopyEnable: true })),
                React.createElement(CpForm, { asnCode: asnCode, selfVasDetailList: selfVasDetailList, handleSearch: handleSearch })))) : null,
        React.createElement(AddFrom, { asnCode: asnCode, editorRecord: editorRecord, addDialogMode: addDialogMode, setAddDialogMode: setAddDialogMode, serviceList: serviceList, existedServiceType: existedServiceType, handleSearch: handleSearch }),
        React.createElement(PublicDialog, { editorRecord: editorRecord, affirmDialogVisible: affirmDialogVisible, setAffirmDialogVisible: setAffirmDialogVisible, closeService: closeService, jumpCashierUrl: jumpCashierUrl, setJumpCashierUrl: setJumpCashierUrl, setCloseService: setCloseService, asnCode: asnCode, serviceList: serviceList, handleSearch: handleSearch })));
}
BizValueAddedService.displayName = componentName;
export { BizValueAddedService };
